module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-d4fb77d1f987e31c316babf468bb10bd.jpg";